import React from 'react';
import PageLayout from '../components/PageLayout';
import './NewsArticles.css';

const NewsArticles = () => {
  const articles = [
    {
      id: 64,
      title: "iPhone Duo for up to Dh13,559? Apple's foldable tests UAE residents' appetite",
      subtitle: "Technologist Rayad Kamal Ayub, managing director of Rayad Group, explains how Apple's on-device AI limits the personal data sent to external infrastructure, noting that much of the privacy architecture belongs to iOS 27 rather than the Duo alone.",
      source: "Khaleej Times",
      date: "2026-09-10",
      link: "https://www.khaleejtimes.com/uae/iphone-duo-price-in-uae-apple-new-foldable-tests-residents-appetite",
      featured: true
    },
    {
      id: 63,
      title: "Dubai's Toyota Building to be demolished next year",
      subtitle: "Rayad Kamal Ayub is quoted on the Sheikh Zayed Road landmark, whose red-and-white neon sign has guided Dubai residents since the 1980s. The 15-storey tower, built in 1974, is scheduled for demolition in 2027.",
      source: "The National",
      date: "2026-08-20",
      link: "https://www.thenationalnews.com/news/uae/2026/08/20/dubai-toyota-building-demolition/",
      featured: false
    },
    {
      id: 62,
      title: "Rayad Group Comments on the Evolving Global Discussion Around AI Access, Digital Resilience & Technological Sovereignty",
      subtitle: "Rayad Group's press release on AI access, digital resilience and technological sovereignty, distributed globally via EIN Presswire to major newswires across the United States, UAE, India and Asia.",
      source: "EIN Presswire",
      date: "2026-06-15",
      link: "https://www.einpresswire.com/press-releases/report-pdf/0SW-fptTvmt2cx6R",
      featured: false
    },
    {
      id: 61,
      title: "Cybersecurity: The new core infrastructure of the UAE economy",
      subtitle: "A new wave of digital threats is pushing the UAE to strengthen the systems powering its digital economy.",
      source: "Khaleej Times",
      date: "2026-06-02",
      link: "https://www.khaleejtimes.com/business-technology-review/cybersecurity-the-new-core-infrastructure-of-the-uae-economy"
    },
    {
      id: 60,
      title: "Commentary: Why UAE is drawing $740 billion in family-office wealth and reshaping global finance",
      subtitle: "The Dubai International Financial Centre now hosts more than 1,289 family-related entities, with family office AUM converging on roughly $740 billion by 2030.",
      source: "Khaleej Times",
      date: "2026-06-01",
      link: "https://www.khaleejtimes.com/business/commentary-why-uae-is-drawing-740-billion-in-family-office-wealth-and-reshaping-global-finance"
    },
    {
      id: 59,
      title: "Children's screen time soars amid US-Israel-Iran war, triggering elevated anxiety levels",
      subtitle: "Analysts observed sustained, algorithmically driven and emotionally intense content that surpassed anything seen prior to the regional conflict; parental awareness must improve.",
      source: "Khaleej Times",
      date: "2026-04-02",
      link: "https://www.khaleejtimes.com/world/asia/children-screen-time-soars-us-israel-iran-war-triggering-elevated-anxiety-levels"
    },
    {
      id: 58,
      title: "$47 million: Influencers winning US-Israel-Iran war by 'peddling lies', analysts say",
      subtitle: "Over 28 days, social media influencers amassed millions by flooding platforms with AI-generated apocalypse content and fabricated disaster videos during the conflict.",
      source: "Khaleej Times",
      date: "2026-03-28",
      link: "https://www.khaleejtimes.com/world/asia/47-million-influencers-winning-us-israel-iran-war-peddling-lies-analysts-say"
    },
    {
      id: 57,
      title: "'Bots' on the ground: How Iran's 400,000-strong web brigade shapes Middle East conflict",
      subtitle: "Before missiles struck in March 2026, automated accounts flooded social media with AI-generated disinformation, creating an invisible digital battlefield alongside kinetic warfare.",
      source: "Khaleej Times",
      date: "2026-03-26",
      link: "https://www.khaleejtimes.com/world/asia/iran-400000-strong-web-brigade-shapes-middle-east-conflict"
    },
    {
      id: 56,
      title: "Over 8,000 Middle East conflict-themed fake websites pose threat to residents",
      subtitle: "Cybersecurity experts warn that sophisticated criminals have registered more than 8,000 fraudulent websites in the past month, with over 200 precisely impersonating major GCC institutions and putting personal data at risk.",
      source: "Khaleej Times",
      date: "2026-03-20",
      link: "https://www.khaleejtimes.com/world/asia/over-8000-middle-east-conflict-themed-fake-websites-threat-residents"
    },
    {
      id: 55,
      title: "Middle East conflict puts the region at risk of ATM 'jackpotting', industry experts warn",
      subtitle: "Geopolitical instability threatens automated teller machine networks across the GCC as organized crime exploits security gaps during crisis periods.",
      source: "Khaleej Times",
      date: "2026-03-18",
      link: "https://www.khaleejtimes.com/world/asia/middle-east-conflict-region-risk-atm-jackpotting-warn-industry-experts"
    },
    {
      id: 54,
      title: "US-Israel-Iran war turns cloud infrastructure into battlefield, tech experts warn",
      subtitle: "Drone strikes on data centers and maritime disruptions are fracturing digital systems and threatening global markets through coordinated cyberattacks and physical infrastructure damage.",
      source: "Khaleej Times",
      date: "2026-03-12",
      link: "https://www.khaleejtimes.com/world/asia/usisraeliran-war-cloud-infrastructure-battlefield-warn-tech-experts"
    },
    {
      id: 53,
      title: "Hormuz shipping disruption puts over Dh10 trillion in global trade at risk",
      subtitle: "Thousands of ships stranded as insurers withdraw war-risk cover and major carriers suspend shipments through the world's most critical energy corridor.",
      source: "Khaleej Times",
      date: "2026-03-09",
      link: "https://www.khaleejtimes.com/business/hormuz-shipping-disruption-puts-over-dh10-trillion-in-global-trade-at-risk-2"
    },
    {
      id: 52,
      title: "Coordinated cyberattacks before US-Israel-Iran airstrikes expose global financial system",
      subtitle: "\"The rules of warfare are being rewritten, hackers weaponise code to inflict more economic devastation than military campaigns,\" warns a cybersecurity analyst.",
      source: "Khaleej Times",
      date: "2026-03-04",
      link: "https://www.khaleejtimes.com/world/asia/cyberattacks-before-us-israel-iran-airstrikes-global-financial-system"
    },
    {
      id: 51,
      title: "Art in Motion: UAE becomes one of the most dynamic destinations for art",
      subtitle: "Villa 88 Magazine features Rayed Kamal and Meena Kamal of MRK Contemporary Art Gallery discussing how the UAE's cultural infrastructure is reshaping the global art scene, with the Guggenheim Abu Dhabi set to open in 2026.",
      source: "Villa 88 Magazine",
      date: "2026-03-01",
      link: "/villa88-art-in-motion.pdf",
      featured: false
    },
    {
      id: 50,
      title: "Iran conflict may trigger unprecedented cyberattacks",
      subtitle: "The Khaleej Times print edition features analysis on how the US-Israel-Iran conflict could trigger unprecedented cyberattacks targeting critical infrastructure and economic systems across the region.",
      source: "Khaleej Times (Print Edition)",
      date: "2026-03-02",
      link: "https://epaper.khaleejtimes.com/khaleej-times/20260302",
      featured: false
    },
    {
      id: 49,
      title: "US-Israel-Iran conflict may trigger unprecedented cyberattacks",
      subtitle: "\"Stakes are high; repercussions can be widespread disruption of critical economic infrastructure, financial systems and logistics,\" warns a Dubai-based cybersecurity analyst.",
      source: "Khaleej Times",
      date: "2026-03-01",
      link: "https://www.khaleejtimes.com/world/asia/usisraeliran-trigger-unprecedented-cyberattacks",
      featured: false
    },
    {
      id: 48,
      title: "UAE-US flights unaffected by air traffic control staffing issues amid govt shutdown",
      subtitle: "Flights between the UAE and US remain unaffected despite over 3,000 delays at US airports caused by air traffic control staffing shortages during the ongoing government shutdown. UAE carriers Emirates and Etihad confirm their flight schedules are not impacted.",
      source: "Khaleej Times",
      date: "2025-10-08",
      link: "https://www.khaleejtimes.com/business/aviation/uae-us-flights-unaffected-air-traffic-control-staffing",
      featured: false
    },
    {
      id: 47,
      title: "Will US visa services in UAE be affected by government shutdown?",
      subtitle: "Following the US federal government's shutdown, US missions in several key cities have issued advisories on cutting down normal operations. Scheduled passport and visa services at US embassies and consulates will continue during the lapse in appropriations as the situation permits.",
      source: "Khaleej Times",
      date: "2025-10-01",
      link: "https://www.khaleejtimes.com/uae/us-visa-service-affect-government-shutdown",
      featured: false
    },
    {
      id: 46,
      title: "Funun Arts Group sews sustainability and connectivity into the fabric of art",
      subtitle: "The article appears to be about an exhibition called \"Threads of Life — An Artistic Tribute to Global Weaves\", organized by Funun Arts Group in collaboration with Novotel Sharjah Expo.",
      source: "Gulf Today",
      date: "2025-08-31",
      link: "https://www.gulftoday.ae/culture/2025/08/31/funun-arts-group-sews-sustainability-and-connectivity-into-the-fabric-of-art",
      featured: false
    },
    {
      id: 1,
      title: "'Game changer': New rupee rule to deepen UAE's trade ties with India, says senior official",
      subtitle: "A senior trade official called India's latest rupee trade reform a 'game changer' that will deepen economic ties between UAE and India. The Reserve Bank of India announced that Indian banks can now open Special Rupee Vostro Accounts for foreign banks without prior approval.",
      source: "Khaleej Times",
      date: "2025-08-12",
      link: "https://www.khaleejtimes.com/world/asia/uae-india-trade-new-rupee-rule",
      featured: false
    },
    {
      id: 2,
      title: "UAE: No more OTPs? 7 new ways banks may authenticate users, fight scams",
      subtitle: "UAE banks will reportedly gradually stop sending one-time passwords (OTPs) via SMS and email for digital transactions starting July 25, according to recent reports.",
      source: "Khaleej Times",
      date: "2025-07-27",
      link: "https://www.khaleejtimes.com/uae/no-otp-how-banks-fight-scams",
      featured: false
    },
    {
      id: 3,
      title: "No more OTPs: UAE banks to switch to app verification starting today",
      subtitle: "The change will apply to all types of local and international financial transfers and online transactions.",
      source: "Khaleej Times",
      date: "2025-07-25",
      link: "https://www.khaleejtimes.com/uae/banks-to-cancel-otp-from-july-25"
    },
    // {
    //   id: 4,
    //   title: "Explained: Why UAE-based holders of 'golden passports' may soon lose visa-free travel in these countries",
    //   subtitle: "As the US and EU tighten rules on citizenship-by-investment programmes, many risk losing the travel freedoms they paid for.",
    //   source: "Times of India",
    //   date: "2025-07-16",
    //   link: "https://timesofindia.indiatimes.com/world/middle-east/thousands-of-uae-residents-who-invested-in-second-passports-fear-visa-bans-as-us-uk-tighten-cbi-rules/amp_articleshow/122279518.cms"
    // },
    {
      id: 6,
      title: "VFS ETM and Rayad Group Partner to Launch U.S. Immigration Advisory Services",
      subtitle: "VFS ETM partners with Rayad Group to deliver expert U.S. immigration advisory services across five major American cities.",
      source: "The Brew News",
      date: "2025-06-01",
      link: "https://thebrewnews.com/brew-circle/vfs-etm-and-rayad-group-partner-to-launch-u-s-immigration-advisory-services/"
    },
    {
      id: 7,
      title: "US Coinbase hack sparks concerns among UAE crypto investors",
      subtitle: "Coinbase has pledged to reimburse customers tricked into transferring funds, with total remediation costs estimated between $180 million and $400 million.",
      source: "Khaleej Times",
      date: "2025-05-16",
      link: "https://www.khaleejtimes.com/business/cryptocurrency/us-coinbase-hack-outsourced-customer-support-agents-bribed-uae-crypto-investors-concerned"
    },
    {
      id: 8,
      title: "Trump to visit UAE, Saudi Arabia, Qatar in three-country tour from May 13",
      subtitle: "Former US President announces diplomatic tour covering three major Gulf countries starting in May.",
      source: "Khaleej Times",
      date: "2025-04-22",
      link: "https://www.khaleejtimes.com/uae/trump-uae-visit-from-may-13"
    },
    {
      id: 9,
      title: "'Hacked and blamed': UAE credit card scam victims call for better protection against fraudsters",
      subtitle: "One teacher lost Dh35,000 while driving. A cybersecurity consultant was defrauded. Many victims insist they never clicked suspicious links yet still found themselves defrauded.",
      source: "Khaleej Times",
      date: "2025-04-05",
      link: "https://www.khaleejtimes.com/uae/uae-scam-residents-accountability-banks-no-otp-fraud"
    },
    {
      id: 10,
      title: "$1.5-billion crypto theft: Dubai authority 'monitoring situation' after Bybit hack",
      subtitle: "Dubai-based crypto exchange Bybit loses $1.5 billion in a sophisticated hack, raising questions about the security and volatility of digital assets.",
      source: "Khaleej Times",
      date: "2025-02-23",
      link: "https://www.khaleejtimes.com/business/cryptocurrency/15-billion-crypto-theft-dubai-authority-monitoring-situation-after-bybit-hack"
    },
    {
      id: 11,
      title: "UAE residents lose money saved for property, flight back home after Dh1 ghee scam",
      subtitle: "A UAE-based company faces a 90% drop in sales after scammers copied its logo and product images, tricking customers into a fake Dh1 ghee deal.",
      source: "Khaleej Times",
      date: "2025-02-19",
      link: "https://www.khaleejtimes.com/uae/crime/dh1-scam-uae-firms-sales-crash-by-90-after-fraudsters-use-logo-to-dupe-buyers-out-of-up-to-dh100000-2"
    },
    {
      id: 12,
      title: "'Loss of up to $200,000 per hour': How bomb threats impact airlines, passengers",
      subtitle: "More than 10 bomb threats targeted Indian carriers on Monday and Tuesday; many of them were posted on social media by unverified users.",
      source: "Khaleej Times",
      date: "2024-10-17",
      link: "https://www.khaleejtimes.com/uae/loss-of-up-to-200000-per-hour-how-bomb-threats-impact-airlines-passengers"
    },
    {
      id: 13,
      title: "UAE exempts VAT for some crypto activities; here's what you need to know",
      subtitle: "New VAT exemptions for cryptocurrency activities announced by UAE authorities, providing clarity for crypto businesses and investors.",
      source: "Khaleej Times",
      date: "2024-10-07",
      link: "https://www.khaleejtimes.com/business/cryptocurrency/uae-exempts-vat-for-some-crypto-activities-heres-what-you-need-to-know"
    },
    {
      id: 14,
      title: "iPhone 16 craze in UAE: Why crowds can't wait to get the latest Apple device every year",
      subtitle: "Experts and users highlight iPhone's appeal beyond status symbol, citing innovation, security, and seamless ecosystem integration driving demand in UAE.",
      source: "Khaleej Times",
      date: "2024-09-22",
      link: "https://www.khaleejtimes.com/business/tech/iphone-16-craze-in-uae-why-crowds-cant-wait-to-get-the-latest-apple-device-every-year"
    },
    {
      id: 15,
      title: "Who still uses a pager in 2024? Experts weigh in",
      subtitle: "Despite smartphone dominance, pagers remain essential in UAE's healthcare, emergency services, and critical infrastructure due to reliability and security.",
      source: "Khaleej Times",
      date: "2024-09-19",
      link: "https://www.khaleejtimes.com/business/tech/uae-who-else-is-still-using-a-pager-in-2024"
    },
    {
      id: 16,
      title: "Experts Highlight the Continued Use of Pagers Amid Security Concerns Following Lebanon Blasts",
      subtitle: "Security experts discuss pager technology and its continued relevance in critical communications following recent security incidents.",
      source: "Emerging Gulf",
      date: "2024-09-19",
      link: "https://emerginggulf.com/uncategorized/experts-highlight-the-continued-use-of-pagers-amid-security-concerns-following-lebanon-blasts/"
    },
    {
      id: 17,
      title: "Dubai International Art Center celebrating India's Independence Day",
      subtitle: "Dubai International Art Center organized art exhibition featuring diverse Indian artistic expressions to commemorate India's Independence Day.",
      source: "Health Magazine UAE",
      date: "2024-08-14",
      link: "https://healthmagazine.ae/press_release/dubai-international-art-center-for-celebrating-indias-independence-day-organized-art-exhibition-colors-of-india-in-dubai/"
    },
    {
      id: 18,
      title: "'I am devastated': Dubai hotelier loses entire life savings to part-time job scam",
      subtitle: "Dubai-based hotelier falls victim to sophisticated employment fraud scheme, losing life savings in fake part-time job opportunity scam targeting expatriates.",
      source: "Khaleej Times",
      date: "2024-08-03",
      link: "https://www.khaleejtimes.com/uae/i-am-devastated-dubai-hotelier-loses-entire-life-savings-to-part-time-job-scam"
    },
    {
      id: 19,
      title: "UAE: Hackers now using AI to extort from social media influencers, celebrities, corporates",
      subtitle: "Cybercriminals increasingly leverage artificial intelligence and deepfake technology to target high-profile individuals and corporations for extortion.",
      source: "Khaleej Times",
      date: "2024-08-02",
      link: "https://www.khaleejtimes.com/uae/uae-hackers-now-using-ai-to-extort-from-social-media-influencers-celebrities-corporates"
    },
    {
      id: 20,
      title: "UAE to issue 3 new policies to boost cybersecurity by end of 2024",
      subtitle: "UAE government announces comprehensive cybersecurity policy framework to strengthen national digital infrastructure protection.",
      source: "Khaleej Times",
      date: "2024-07-27",
      link: "https://www.khaleejtimes.com/uae/uae-to-issue-3-new-policies-to-boost-cybersecurity-by-end-of-2024"
    },
    {
      id: 21,
      title: "CrowdStrike crash: Should UAE residents be wary of automatic IT updates?",
      subtitle: "Security experts discuss the balance between automatic updates and system stability following the major CrowdStrike incident.",
      source: "Khaleej Times",
      date: "2024-07-24",
      link: "https://www.khaleejtimes.com/uae/crowdstrike-crash-should-uae-residents-be-wary-of-automatic-it-updates"
    },
    {
      id: 22,
      title: "Tech outage hits UAE: How Crowdstrike crash disrupted life and what happens next",
      subtitle: "Global CrowdStrike outage significantly impacted UAE government systems, Dubai Airport, and various services, highlighting cybersecurity dependencies.",
      source: "Khaleej Times",
      date: "2024-07-20",
      link: "https://www.khaleejtimes.com/uae/tech-outage-hits-uae-how-crowdstrike-crash-disrupted-life-and-what-happens-next"
    },
    {
      id: 23,
      title: "UAE: Does your child play Roblox? Experts warn of cyber threats on gaming platforms",
      subtitle: "Cybersecurity experts highlight potential risks and safety concerns for children using popular gaming platforms like Roblox.",
      source: "Khaleej Times",
      date: "2024-07-15",
      link: "https://www.khaleejtimes.com/entertainment/gaming/uae-does-your-child-play-roblox-experts-warns-of-cyber-threats-on-gaming-platforms"
    },
    {
      id: 24,
      title: "Emirati child prodigies to make debut at World Art Dubai 2025",
      subtitle: "Eight young Emirati artists showcase paintings, caricatures, portraits, and digital art demonstrating remarkable emotional depth and technical skill.",
      source: "Khaleej Times",
      date: "2024-04-15",
      link: "https://www.khaleejtimes.com/lifestyle/arts/emirati-child-prodigies-to-make-debut-at-world-art-dubai-2025"
    },
    {
      id: 25,
      title: "\"Colors of India\" Art Exhibition",
      subtitle: "Art exhibition celebrating India's Independence Day featuring diverse Indian artistic expressions and cultural heritage.",
      source: "OneVille News",
      date: "2024-08-20",
      link: "https://onevillenews.com/2024/08/20/colors-of-india-art-exhibition/"
    },
    {
      id: 26,
      title: "UAE Company Reports 90% Sales Decline as Fraudsters Use Its Logo in Dh1 Scam",
      subtitle: "A UAE-based company faces a 90% drop in sales after scammers copied its logo and product images, tricking customers into a fake Dh1 ghee deal.",
      source: "Gulf Articles",
      date: "2025-02-19",
      link: "https://www.gulfarticles.com/uae-company-sales-scam/"
    },
    // {
    //   id: 27,
    //   title: "VFS Global and Rayad Group Launch Golden Visa Advisory Services for Indian Applicants",
    //   subtitle: "VFS Global partners with Rayad Group to deliver comprehensive golden visa advisory services for Indian nationals seeking UAE residency.",
    //   source: "Khaleej Mag",
    //   date: "2025-07-08",
    //   link: "https://khaleejmag.com/industry/vfs-global-and-rayad-group-launch-golden-visa-advisory-services-for-indian-applicants/"
    // },
    {
      id: 28,
      title: "VFS ETM partners with Rayad Group to provide immigration advisory services in India",
      subtitle: "VFS ETM expands immigration services in India through strategic partnership with Rayad Group to provide expert advisory services.",
      source: "Travel Biz Monitor",
      date: "2025-06-24",
      link: "https://travelbizmonitor.com/top-stories/vfs-etm-partners-with-rayad-group-to-provide-immigration-advisory-services-in-india/"
    },
    // {
    //   id: 29,
    //   title: "Trump offers 'golden visa': UAE investors looking for Green Card have to pay 525% more",
    //   subtitle: "The EB-5 programme, which currently allows foreign investors to secure a Green Card through an $800,000 investment in a US job-creating project, may soon be eliminated entirely.",
    //   source: "Khaleej Times",
    //   date: "2025-02-28",
    //   link: "https://www.khaleejtimes.com/uae/trumps-gold-card-is-time-running-out-for-prospective-uae-investors-to-get-permanent-us-visa"
    // },
    // {
    //   id: 30,
    //   title: "UAE opens Golden Visa for Indians without investment: What's the catch?",
    //   subtitle: "UAE introduces new pathway for Indian nationals to obtain Golden Visa without traditional investment requirements, with specific eligibility criteria.",
    //   source: "Mathrubhumi",
    //   date: "2025-07-07",
    //   link: "https://english.mathrubhumi.com/lifestyle/travel/uae-golden-visa-no-investment-residency-indian-nomination-process-ib0cwve1"
    // },
    {
      id: 31,
      title: "Everything under the sun: many styles mark DIAC affordable art summer show",
      subtitle: "Dubai International Art Center showcases diverse artistic styles and affordable art pieces in special summer exhibition featuring local and international artists.",
      source: "Gulf Today",
      date: "2024-07-18",
      link: "https://www.gulftoday.ae/culture/2024/07/18/everything-under-the-sun-many-styles-mark-diac-affordable-art-summer-show"
    },
    {
      id: 32,
      title: "\"CBI Must Adapt or Be Shut Out\": Investment Migration People in the News This Week",
      subtitle: "Investment migration experts discuss the evolving landscape of citizenship-by-investment programs and the need for adaptation in changing regulatory environment.",
      source: "IMI Daily",
      date: "2025-07-07",
      link: "https://www.imidaily.com/im-people-in-the-news/cbi-must-adapt-or-be-shut-out-investment-migration-people-in-the-news-this-week/"
    },
    {
      id: 33,
      title: "UAE govt services, flights hit as systems crash in global cyber outage",
      subtitle: "Government services and airport operations were among those hit by the cyber outage in the Emirates, causing widespread disruption.",
      source: "Khaleej Times",
      date: "2024-07-20",
      link: "https://www.khaleejtimes.com/uae/uae-govt-systems-dubai-airport-hit-by-global-tech-outage"
    },
    {
      id: 34,
      title: "VFS ETM and Rayad Group Launch Advanced Immigration Advisory Services in India",
      subtitle: "Partnership announcement for comprehensive immigration advisory services targeting Indian nationals seeking international residency opportunities.",
      source: "The Brew News",
      date: "2025-06-23",
      link: "https://thebrewnews.com/business/vfs-etm-and-rayad-group-launch-advanced-immigration-advisory-services-in-india/"
    },
    {
      id: 35,
      title: "Tech Outage in UAE: How the CrowdStrike Crash Disrupted Daily Life and What Comes Next?",
      subtitle: "Massive IT failure causes widespread disruption, affecting flights, payments, and essential services across the UAE.",
      source: "The Law Reporters",
      date: "2024-07-20",
      link: "https://thelawreporters.com/tech-outage-in-uae-how-crowdstrike-crash-disrupted-daily-life-and-what-comes-next"
    },
    {
      id: 36,
      title: "VFS ETM partners with Rayad Group to provide immigration advisory services in India",
      subtitle: "Strategic partnership announcement to enhance immigration advisory services for Indian nationals seeking international opportunities.",
      source: "Travel Trade Journal",
      date: "2025-06-23",
      link: "https://traveltradejournal.com/vfs-etm-partners-with-rayad-group-to-provide-immigration-advisory-services-in-india/"
    },
    {
      id: 37,
      title: "Passwords hacked worldwide: UAE companies urged to boost IT security",
      subtitle: "The gravity of this situation cannot be overstated; this is weaponising intelligence at scary scales for extortion, experts say.",
      source: "Khaleej Times",
      date: "2025-06-22",
      link: "https://www.khaleejtimes.com/business/tech/16-billion-passwords-hacked-worldwide-cybersecurity-experts-security"
    },
    {
      id: 38,
      title: "90% Sales Crash! How Scammers Hijacked a UAE Brand to Rob Innocent Shoppers",
      subtitle: "UAE company reports massive sales decline after fraudsters use its logo and branding in sophisticated scam targeting unsuspecting consumers.",
      source: "Arab Times Online",
      date: "2025-02-19",
      link: "https://www.arabtimesonline.com/news/90-sales-crash-how-scammers-hijacked-a-uae-brand-to-rob-innocent-shoppers/"
    },
    {
      id: 39,
      title: "Israel-Iran conflict: Cyberwarfare will continue despite ceasefire, experts say",
      subtitle: "Experts warned that hacking attempts, espionage operations, and sabotage efforts will not only continue but can also intensify under the radar.",
      source: "Khaleej Times",
      date: "2025-06-27",
      link: "https://www.khaleejtimes.com/uae/israel-iran-conflict-cyberwarfare-ceasefire"
    },
    {
      id: 40,
      title: "Got UAE Pass OTP request? Scammers pose as officials to bully victims for info",
      subtitle: "The TDRA has confirmed the app is secure; however, scammers continue to use sophisticated tactics to try and con residents.",
      source: "Khaleej Times",
      date: "2024-07-13",
      link: "https://www.khaleejtimes.com/uae/crime/got-uae-pass-otp-request-fraudsters-pose-as-officials-to-bully-victims-for-info"
    },
    {
      id: 41,
      title: "Cyber outage disrupts UAE government services and Dubai International Airport operations",
      subtitle: "Global cyber outage significantly impacts UAE government systems and Dubai Airport operations, highlighting critical infrastructure vulnerabilities.",
      source: "The Global Filipino Magazine",
      date: "2024-07-19",
      link: "https://theglobalfilipinomagazine.com/cyber-outage-disrupts-uae-government-services-and-dubai-international-airport-operations/"
    },
    {
      id: 42,
      title: "VFS ETM partners with Rayad Group to provide immigration advisory services in India",
      subtitle: "Comprehensive immigration advisory services partnership to support Indian nationals in international migration and residency applications.",
      source: "Travel Heights",
      date: "2025-06-23",
      link: "https://travelheights.org/vfs-etm-partners-with-rayad-group-to-provide-immigration-advisory-services-in-india/"
    },
    {
      id: 43,
      title: "Bomb Threats on Flights: A Serious Concern",
      subtitle: "UAE-based experts weigh in on the recent spate of hoax bomb threats disrupting Indian flights and their impact on aviation security.",
      source: "World Arabia",
      date: "2024-10-17",
      link: "https://world-arabia.com/articles/bomb-threats-on-flights-a-serious-concern/"
    },
    {
      id: 44,
      title: "Technology outage impacts UAE: The chaos caused by Crowdstrike crash and what comes next",
      subtitle: "Analysis of the widespread technology outage impact on UAE infrastructure and services following the CrowdStrike incident.",
      source: "Gulf Press",
      date: "2024-07-20",
      link: "https://gulfpress.net/gulf/uae/technology-outage-impacts-uae-the-chaos-caused-by-crowdstrike-crash-and-what-comes-next/"
    },
    {
      id: 45,
      title: "Bybit Faces Regulatory Hurdles and Massive Crypto Hack",
      subtitle: "Dubai-based cryptocurrency exchange Bybit encounters significant regulatory challenges while dealing with massive security breach affecting millions of users.",
      source: "Gulf Articles",
      date: "2025-02-24",
      link: "https://www.gulfarticles.com/bybit-regulatory-issues-crypto-hack/"
    }
  ];

  // Sort articles by date (latest first) and format dates for display
  const sortedArticles = [...articles]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .map(article => ({
      ...article,
      displayDate: new Date(article.date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }));

  return (
    <PageLayout title="News Articles" subtitle="Latest press releases and media coverage">
      <div className="news-articles-container">
        <div className="articles-grid">
          {sortedArticles.map((article, i) => (
            <article key={"" + i} className={`article-card ${article.featured ? 'featured' : ''}`}>
              <div className="article-content">
                {article.featured && <span className="featured-badge">Latest News</span>}
                <h2 className="article-title">{article.title}</h2>
                <p className="article-subtitle">{article.subtitle}</p>
                <div className="article-meta">
                  <span className="article-source">{article.source}</span>
                  <span className="article-date">{article.displayDate}</span>
                </div>
                <a 
                  href={article.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="article-link"
                >
                  Read Full Article →
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </PageLayout>
  );
};

export default NewsArticles;